import React from 'react'
import { motion } from 'framer-motion'
import { Download, Star, Users, BookOpen } from 'lucide-react'
import PlayStore from '../assets/images/Playstore.png'
import Apple from '../assets/images/Apple.png'
import youthTM from '../assets/images/youthTM.png'


export default function AppDownload({
    playStoreUrl = "https://play.google.com/store/apps/details?id=youth.ncert.papergeneration",
    appStoreUrl = "https://apps.apple.com/in/app/youth-paper-generation-1-to-12/id6497714615"
}) {
    return (
        <div className="block md:hidden min-h-screen bg-gradient-to-br from-blue-500 via-blue-400 to-blue-600 relative overflow-hidden">
            {/* Animated background elements */}
            <motion.div
                className="absolute inset-0 opacity-10"
                initial={{ backgroundSize: "100% 100%" }}
                animate={{
                    backgroundImage: [
                        "radial-gradient(circle at 0% 0%, white 0%, transparent 50%)",
                        "radial-gradient(circle at 100% 100%, white 0%, transparent 50%)",
                        "radial-gradient(circle at 0% 0%, white 0%, transparent 50%)",
                    ],
                }}
                transition={{ duration: 10, repeat: Infinity }}
            />

            <div className="relative z-10 flex flex-col items-center justify-center min-h-screen p-6 text-white">
                {/* App Icon */}
                <motion.div
                    initial={{ y: 20, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.5 }}
                    className="mb-8"
                >
                    <div className="bg-white  rounded-md shadow-lg flex items-center justify-center">
                        <img alt='' src={youthTM} className='w-32  rounded-md' />
                    </div>
                </motion.div>

                {/* App Title and Description */}
                <motion.div
                    initial={{ y: 20, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.5, delay: 0.2 }}
                    className="text-center mb-8"
                >
                    <h1 className="text-3xl font-bold mb-4">Youth Paper Generation</h1>
                    <p className="text-lg opacity-90 mb-6">
                        Get our app for a better learning experience
                    </p>
                </motion.div>

                {/* Stats */}
                <motion.div
                    initial={{ y: 20, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.5, delay: 0.4 }}
                    className="grid grid-cols-2 gap-4 mb-8 w-full max-w-xs"
                >
                    <div className="bg-white/20 rounded-lg p-4 backdrop-blur-sm text-center">
                        <Users className="w-6 h-6 mx-auto mb-2" />
                        <p className="text-lg font-bold">500K+</p>
                        <p className="text-sm opacity-90">Downloads</p>
                    </div>
                    <div className="bg-white/20 rounded-lg p-4 backdrop-blur-sm text-center">
                        <Star className="w-6 h-6 mx-auto mb-2" />
                        <p className="text-lg font-bold">4.5</p>
                        <p className="text-sm opacity-90">Rating</p>
                    </div>
                </motion.div>

                {/* Download Buttons */}
                <motion.div
                    initial={{ y: 20, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.5, delay: 0.6 }}
                    className="space-y-4 w-full max-w-xs"
                >
                    <a
                        href={playStoreUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center justify-center w-full bg-white text-blue-600 rounded-lg p-4 shadow-lg hover:bg-opacity-90 transition-all transform hover:scale-105"
                    >
                        <img src={PlayStore} alt="Play Store" className="w-5  mr-2" />
                        Get it on Google Play
                    </a>
                    <a
                        href={appStoreUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center justify-center w-full bg-black text-white rounded-lg p-4 shadow-lg hover:bg-opacity-90 transition-all transform hover:scale-105"
                    >
                        <img src={Apple} alt='App Store' className="w-5  mr-2" />
                        Download on App Store
                    </a>
                </motion.div>
            </div>
        </div>
    )
}